/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewrefreshing2Inputs */

const en_letterpreviewrefreshing2 = /** @type {(inputs: Letterpreviewrefreshing2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regenerating…`)
};

const pt_letterpreviewrefreshing2 = /** @type {(inputs: Letterpreviewrefreshing2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A gerar…`)
};

/**
* | output |
* | --- |
* | "Regenerating…" |
*
* @param {Letterpreviewrefreshing2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewrefreshing2 = /** @type {((inputs?: Letterpreviewrefreshing2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewrefreshing2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewrefreshing2(inputs)
	return pt_letterpreviewrefreshing2(inputs)
});
export { letterpreviewrefreshing2 as "letterPreviewRefreshing" }